import { sendRequest, ppAxios } from '../config'

/**
 * 物流管理-列表查询
 */
export const logisticsList = (param) => {
  return sendRequest(['POST', '/merchant/acquirer/logistics/list'], param)
}
/**
 * 物流管理-单个上传
 */
export const singleUpload = (param) => {
  return sendRequest(['POST', '/merchant/acquirer/logistics/singleUpload'], param)
}
/**
 * 物流管理-批量上传
 */
export const batchUpload = (param) => {
  return sendRequest(['POST', '/merchant/acquirer/logistics/batchUpload'], param)
}
/**
 * 物流管理-查询未上传物流信息数量
 */
export const queryNonUploadCount = (param) => {
  return sendRequest(['GET', '/merchant/acquirer/logistics/queryNonUploadCount'], param)
}

/**
 * 提现前校验 - 当前Client ID下是否存在已结算但未上传的订单信息
 */
export const queryIsSettledButOrderInfoDefect = () => {
  return sendRequest(['GET', '/merchant/acquirer/logistics/queryIsSettledButOrderInfoDefect'])
}

/**
 * 物流管理-是否有新增待上传物流交易（New标签显示）
 */
export const queryNew = (param) => {
  return sendRequest(['GET', '/merchant/acquirer/logistics/queryNew'], param)
}

/**
 * 物流管理-下载批量导入模板
 */
export const downloadTemplate = (option) => {
  return ppAxios(['GET', '/merchant/acquirer/logistics/downloadTemplate'], {}, option)
}

/**
 *物流管理-导出当前结果
 */
export const exportLogisticsInfo = (param, option) => {
  return ppAxios(['POST', '/merchant/acquirer/logistics/exportLogisticsInfo'], param, option)
}

